import * as React from "react";

import { useUserContext } from "../../user-provider";
import { useNavigate } from "react-router-dom";
import { useUtilityContext } from "../../utility-provider";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { apiRequest } from "../../api/ApiCall";
import { encryptQueryParam, decryptQueryParam } from '../../utility/util';

import { getLongPageData } from "../../data/DataManage";
import { mpData, calculateColumnTotal } from "../subPage/TradeArea/TradeAreaFunction";
import Approval5mcutModal from "../subPage/Approval5mcut/Approval5mcutModal";
import { setStatushLog } from "../../features/longPageSlice";
import { conflictResearchList } from "../subPage/Interface";
import { Box, Button } from "@mui/material";
import { setObjCover } from "../../features/coverSlice";
import { coverData } from "../subPage/Cover/CoverFunction";
import Approval5mcutDetail from "../subPage/Approval5mcut/Approval5mcutDetail";
import ApprovalMarketCutDetail from "../subPage/Approval5mcut/ApprovalMarketCutDetail";
import { setParent5mcut, setParentMarketCut, setChild5mcut, setChildMarketCut, setHasChild, setParentLocationBase, setChildLocationBase, setParentLocationCover, setChildLocationCover } from "../../features/approval5mcutSlice";
import { LOCAL_CONSTANT } from "../Const";

interface resultProps {
    props: {};
}

const infoBarStyle = {
    margin: "10px 0", 
    backgroundColor: "#ffa500", 
    fontWeight: "bold", 
    textAlign: "center" 
};

const Approval5mcut: React.FC<resultProps> = ({ props }) => {
    const user = useUserContext();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const utilityCtx = useUtilityContext();
    const [windowSize, setWindowSize] = React.useState({ width: window.innerWidth, height: window.innerHeight });
    const [codeMaster, setCodeMaster] = React.useState<any>();

    //URLパラメータ
    const [planAreaId, setPlanAreaId] = React.useState("");
    const [branch, setBranch] = React.useState("");

    const [locationConflict, setLocationConflict] = React.useState<conflictResearchList[]>([]);
    const [locationSMDS, setLocationSMDS] = React.useState<conflictResearchList[]>([]);
    const [childLocationConflict, setChildLocationConflict] = React.useState<conflictResearchList[]>([]);
    const [childLocationSMDS, setChildLocationSMDS] = React.useState<conflictResearchList[]>([]);
    const [receptionBook, setReceptionBook] = React.useState<any>({});
    const [approval5mcutModalOpen, setApproval5mcutModalOpen] = React.useState<boolean>(false);
    const [userData, setUserData] = React.useState<any>({});

    //候補地情報
    const [planAreaInfoData, setPlanAreaInfoData] = React.useState<any>();
    const objStorePlanAreaId = useAppSelector((state) => state.longPage.storePlanAreaId);
    const [childLocation, setChildLocation] = React.useState("");
    const objParentLocationBase = useAppSelector((state) => state.approval5mcut.parentLocationBase);
    const objParent5mcut = useAppSelector((state) => state.approval5mcut.parent5mcut);
    const objParentMarketCut = useAppSelector((state) => state.approval5mcut.parentMarketCut);
    const objChild5mcut = useAppSelector((state) => state.approval5mcut.child5mcut);
    const objChildMarketCut = useAppSelector((state) => state.approval5mcut.childMarketCut);
    const objParentLocationCover = useAppSelector((state) => state.approval5mcut.parentLocationCover);
    const objChildLocationCover = useAppSelector((state) => state.approval5mcut.childLocationCover);
    const hasChild = useAppSelector((state) => state.approval5mcut.hasChild);
    //調査書基本
    const objLocationBase = useAppSelector((state) => state.longPage.locationBase);

    // 子調査書
    const [childPlanAreaId, setChildPlanAreaId] = React.useState("");

    React.useEffect(() => {
        const res: any = localStorage.getItem("codeMaster");
        if (res) {
            const d = JSON.parse(res);
            setCodeMaster(d);
        }
    }, []);

    const [marketCutData, setMarketCutData] = React.useState({});
    const [childMarketCutData, setChildMarketCutData] = React.useState({});

    React.useEffect(() => {
        //暗号化されたクエリパラメータを復号化
        const search = window.location.search;
        const urlParam = search.substring(1);
        decryptQueryParam(urlParam).then((res) => {
            setPlanAreaId(res[0]);
            setBranch(res[1]);
        }).catch((e:any) => {
            console.log(e);
        });
        function handleResize() {
            // ヘッダーの分を引く
            const tempHeight = window.innerHeight - 48;
            // ハンバーガーメニューの分を引く
            const tempWidth = window.innerWidth - 56;
            setWindowSize({ width: tempWidth, height: tempHeight });
        }

        // 初回ロード時のサイズに基づいてスケーリング
        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    React.useEffect(() => {
        if(planAreaId !== "" && branch !== ""){
            loadApi();
        }
    }, [planAreaId, branch]);

    React.useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserData(JSON.parse(user.userData));
        }
    }, [user]);

    const loadApi = async () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        let hasFin = false;
        callApi("getApproval5mCutLocationBase", [])
            .then((res: any) => {
                if (res.getApproval5mCutLocationBase.length > 0) {
                    // 親調査書
                    dispatch(setParentLocationBase(res.getApproval5mCutLocationBase[0]));
                    callApi("getData", {
                        planAreaId: planAreaId,
                        location_excel_sequence: res.getApproval5mCutLocationBase[0].location_excel_sequence,
                    })
                        .then((dataRes: any) => {
                            dispatch(setParent5mcut(dataRes.getLocationTraffic5mcut[0]));
                            dispatch(setParentMarketCut(dataRes.getLocationConflictMarketCut[0]));

                            if (res.getApproval5mCutLocationBase[0].location_excel_sequence !== "0") {
                                const listResult = levelingMarketCut(dataRes);
                                setMarketCutData(listResult);
                            }
                            // カット基礎競合店
                            let tmpList = {
                                CVS: [],
                                SMDS: [],
                            };
                            if (dataRes.getLocationConflict.length > 0) {
                                tmpList = levelingLocationConflict(dataRes);
                            }
                            setLocationConflict(tmpList.CVS);
                            setLocationSMDS(tmpList.SMDS);

                            // 表紙
                            dispatch(setObjCover(coverData(dataRes.getLocationCover)));
                            dispatch(setParentLocationCover(coverData(dataRes.getLocationCover)));
                            setReceptionBook(dataRes.getReceptionBookByIdAndBranch[0]);
                            callChangeHistory();
                            getPlanAreaInfo();
                            if (res.getApproval5mCutLocationBase[0].location_type === "04" || (res.getApproval5mCutLocationBase[0].location_type === "02" && res.getApproval5mCutLocationBase[0].child_location_type === "07")) {
                                // 子調査書データ取得
                                setChildPlanAreaId(res.getApproval5mCutLocationBase[0].use_plan_area_id);
                                setChildLocation(res.getApproval5mCutLocationBase[0].child_location);
                                callApi("getData", {
                                    planAreaId: res.getApproval5mCutLocationBase[0].use_plan_area_id,
                                    location_excel_sequence: res.getApproval5mCutLocationBase[0].child_location_excel_sequence,
                                })
                                    .then((approvalResult: any) => {
                                        dispatch(setChildLocationBase(approvalResult.getApproval5mCutLocationBase[0]));
                                        dispatch(setChild5mcut(approvalResult.getLocationTraffic5mcut[0]));
                                        dispatch(setChildMarketCut(approvalResult.getLocationConflictMarketCut[0]));
                                        // 表紙
                                        dispatch(setChildLocationCover(coverData(approvalResult.getLocationCover)));
                                        if (res.getApproval5mCutLocationBase[0].child_location_excel_sequence !== "0") {
                                            const childListResult = levelingMarketCut(approvalResult);
                                            setChildMarketCutData(childListResult);
                                        }
                                        // カット基礎競合店
                                        let child_tmpList = {
                                            CVS: [],
                                            SMDS: [],
                                        };
                                        if (approvalResult.getLocationConflict.length > 0) {
                                            child_tmpList = levelingLocationConflict(approvalResult);
                                        }
                                        setChildLocationConflict(child_tmpList.CVS);
                                        setChildLocationSMDS(child_tmpList.SMDS);
                                        dispatch(setHasChild(true));
                                    })
                                    .catch((e) => {
                                        console.log(e);
                                    })
                                    .finally(() => {
                                        if (utilityCtx.hideSpinner) {
                                            utilityCtx.hideSpinner();
                                        }
                                    });
                            } else {
                                hasFin = true;
                            }
                        })
                        .catch((e) => {
                            console.log(e);
                            if (utilityCtx.hideSpinner) {
                                utilityCtx.hideSpinner();
                            }
                        })
                        .finally(() => {
                            if (hasFin) {
                                if (utilityCtx.hideSpinner) {
                                    utilityCtx.hideSpinner();
                                }
                            }
                        });
                }
            })
            .catch((e) => {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            });
    };

    const levelingMarketCut = (data: any) => {
        const marketCutList = {
            households: 0,
            employees: 0,
            delete_households: 0,
            delete_employees: 0,
            substance_households: 0,
            substance_employees: 0,
        };
        let listMpData: any = {};
        // location_excel_04_mp_dataとlocation_excel_05_mp_data2とlocation_trade_areaにデータが存在する場合
        if (data.getLocationTradeAreaMpData.length > 0) {
            listMpData = mpData(data.getLocationTradeAreaMpData, objLocationBase.trade_area_reality_flag);
            // location_excel_04_mp_dataとlocation_excel_05_mp_data2にデータが存在する場合
        } else if (data.getGradientWalk5MinMpData.length > 0) {
            listMpData = mpData(data.getGradientWalk5MinMpData, objLocationBase.trade_area_reality_flag);
        }
        const reality_survey_household_count = Math.round(calculateColumnTotal("reality_survey_household_count", listMpData, objLocationBase.trade_area_reality_flag));
        const reality_survey_employed_workers = Math.round(calculateColumnTotal("reality_survey_employed_workers", listMpData, objLocationBase.trade_area_reality_flag));
        // 徒歩5分商圏
        marketCutList.households = reality_survey_household_count;
        marketCutList.employees = reality_survey_employed_workers;
        // 削除商圏
        marketCutList.delete_households = data.getLocationConflictMarketCut[0]["households"];
        marketCutList.delete_employees = data.getLocationConflictMarketCut[0]["employees"];
        // 実質商圏
        if (marketCutList.households - marketCutList.delete_households > 0) {
            marketCutList.substance_households = marketCutList.households - marketCutList.delete_households;
        }
        if (marketCutList.employees - marketCutList.delete_employees > 0) {
            marketCutList.substance_employees = marketCutList.employees - marketCutList.delete_employees;
        }

        return marketCutList;
    };

    const levelingLocationConflict = (data: any) => {
        const tmpCVS: any = [];
        const tmpSMDS: any = [];
        if (data.getLocationConflict.length > 0) {
            data.getLocationConflict.map((row: any) => {
                // 99（自店）
                if (row.conflict_sequence !== "99") {
                    if (["0", "1"].includes(row.conflict_type) && row.market_cut === "1") {
                        tmpCVS.push(row);
                    } else if (["2", "3"].includes(row.conflict_type) && row.market_cut === "1") {
                        tmpSMDS.push(row);
                    }
                }
            });
        }

        return {
            CVS: tmpCVS,
            SMDS: tmpSMDS,
        };
    };

    const callApi = async (target: string, params: any) => {
        const param: any = [];
        if (target === "getApproval5mCutLocationBase") {
            param.push({
                mode: "getApproval5mCutLocationBase",
                plan_area_id: planAreaId,
                branch: branch,
            });
        } else if (target === "getData") {
            // 5m外
            param.push({
                mode: "getLocationTraffic5mcut",
                plan_area_id: params.planAreaId,
                branch: branch,
            });
            // 商圏用
            param.push({
                mode: "getLocationTradeAreaMpData",
                plan_area_id: params.planAreaId,
                branch: branch,
                excel_sequence: params.location_excel_sequence,
            });
            param.push({
                mode: "getGradientWalk5MinMpData",
                plan_area_id: params.planAreaId,
                excel_sequence: params.location_excel_sequence,
            });
            // カット基礎競合店
            param.push({
                mode: "getLocationConflict",
                plan_area_id: params.planAreaId,
                branch: branch,
            });
            // 商圏カット
            param.push({
                mode: "getLocationConflictMarketCut",
                plan_area_id: params.planAreaId,
                branch: branch,
            });
            param.push({
                mode: "getLocationCover",
                plan_area_id: params.planAreaId,
                branch: branch,
            });
            param.push({
                mode: "getReceptionBookByIdAndBranch",
                plan_area_id: params.planAreaId,
                branch: branch,
            });

            param.push({
                mode: "getApproval5mCutLocationBase",
                plan_area_id: params.planAreaId,
                branch: branch,
            });
        }

        return await getLongPageData(param);
    };

    const callChangeHistory = () => {
        const params = {
            mode: "regist",
            endPoint: "/location/system/v1/get-log",
            query: {
                plan_area_id: planAreaId,
                branch: branch,
                log_type: "status",
            },
        };
        (async () => {
            try {
                const res = await apiRequest(params);
                dispatch(setStatushLog(res.data));
            } catch (e) {
                console.log(e);
            }
        })();
    };

    // 候補地情報取得
    const getPlanAreaInfo = () => {
        let searchPlanAreaId = planAreaId;
        if (planAreaId !== null) {
            if (planAreaId.startsWith("X") || planAreaId.startsWith("Y")) {
                searchPlanAreaId = objStorePlanAreaId;
            }
        }
        const params = {
            mode: "regist",
            endPoint: "/sfdc/planArea/v1/info",
            query: {
                plan_area_id: searchPlanAreaId,
            },
        };
        (async () => {
            try {
                const apiPlanAreaInfo = await apiRequest(params);
                if (apiPlanAreaInfo.data.dataList.length > 0) {
                    const planAreaInfoJSON = JSON.parse(apiPlanAreaInfo.data.dataList[0]);
                    setPlanAreaInfoData(planAreaInfoJSON);
                }
            } catch (e) {
                console.log(e);
            }
        })();
    };

    const disabledApproval = () => {
        // 承認/差戻の活性、非活性
        // 活性がfalse、非活性がtrue
        
        // RRの場合
        if (LOCAL_CONSTANT.RR_DEPARTMENT.includes(userData.department_code_OA)) {
            // RRMgrの活性化条件
            // D004(Mgr承認待ち Mgr 5m外・商圏カットMgr事前承認)：職種がMgrかつ所属がリクルートリサーチの時
            if (["230"].includes(userData.job_category_code_OA)) {
                if (["D004"].includes(receptionBook?.task_id)) {
                    return false;
                } else {
                    return true;
                }
            // RRGMの活性化条件
            // D005(RR GM承認待ち RR GM 5m外・商圏カットRR GM事前承認)：職種がAGMまたはGM、かつ所属がリクルートリサーチの時
            } else if (["101", "102"].includes(userData.job_category_code_OA)) {
                if (["D005"].includes(receptionBook?.task_id)) {
                    return false;
                } else {
                    return true;
                }
            // 職種がMgr,AGM,GM以外はボタン非活性化
            } else {
                return true;
            }
        } else {
            // RR以外の場合
            // departmentMasterにあるdepartment_code_oaかdistrict_code_oaに該当するかチェック
            const departmentMasterObj = localStorage.getItem("departmentMaster");
            let isValidDepartment = false;
            
            if (departmentMasterObj !== null && departmentMasterObj !== "undefined") {
                const jsonDepartmentMasterObj = JSON.parse(departmentMasterObj);
                isValidDepartment = jsonDepartmentMasterObj.some((dept: any) => 
                    dept.department_code_oa === userData.department_code_OA || 
                    dept.district_code_oa === userData.department_code_OA
                );
            }
            
            if (isValidDepartment) {
                // 現場RMの活性化条件
                // D007(RM承認待ち RM 5m外・商圏カットRM事前承認)：職種がMgrかつ所属がリクルートリサーチ以外の時
                if (userData.job_category_code_OA === "230") {
                    if (["D007"].includes(receptionBook?.task_id)) {
                        return false;
                    } else {
                        return true;
                    }
                // 現場GMの活性化条件
                // D008(GM承認待ち GM 5m外・商圏カットGM事前承認)：職種がAGMまたはGM、かつ所属がリクルートリサーチ以外の時
                } else if (["101", "102"].includes(userData.job_category_code_OA)) {
                    if (["D008"].includes(receptionBook?.task_id)) {
                        return false;
                    } else {
                        return true;
                    }
                // 職種がMgr,AGM,GM以外はボタン非活性化
                } else {
                    return true;
                }
            } else {
                // departmentMasterに該当しない場合は非活性
                return true;
            }
        }
    };

    const openApproval5mcutModal = () => {
        setApproval5mcutModalOpen(true);
    };

    const closeApproval5mcutModal = (regist: boolean) => {
        setApproval5mcutModalOpen(false);
        if (regist) {
            navigate("/");
        }
    };

    const gotoLocation = () => {
        // 別タブで開く
        const baseUrl = window.location.origin;
        const param = `planAreaId=${planAreaId}&branch=${branch}`;
        encryptQueryParam(param).then((res) => {
            const fullPath = `${baseUrl}/LongPage?` + res;
            window.open(fullPath);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    };

    return (
        <Box sx={{ width: windowSize.width + 56, height: windowSize.height + 56, overflowY: "scroll" }}>
            <Box sx={{ width: "100%" }}>
                <Box sx={{ padding: "70px 0 20px 40px" }}>
                    <Box>
                        <Button variant="contained" color="success" size="small" sx={{ padding: "10px 20px" }} onClick={gotoLocation}>
                            調査書
                        </Button>
                    </Box>
                    {(objParentLocationBase.location_type === "01" || objParentLocationBase.location_type === "10") && <Box sx={infoBarStyle}>{`${objParentLocationCover.survey_name}：${planAreaId}`}</Box>}
                    {hasChild === true && <Box sx={infoBarStyle}>{`B店承認（${objParentLocationCover.survey_name}：${planAreaId}）`}</Box>}
                    <Approval5mcutDetail
                        props={{
                            planAreaId: planAreaId,
                            branch: branch,
                            locationTraffic5mcut: objParent5mcut,
                        }}
                    />
                    <ApprovalMarketCutDetail
                        props={{
                            planAreaId: planAreaId,
                            branch: branch,
                            locationConflictMarketCut: objParentMarketCut,
                            locationConflict: locationConflict,
                            locationSMDS: locationSMDS,
                            marketCut: marketCutData,
                            codeMaster: codeMaster,
                        }}
                    />
                    {hasChild === true && <Box sx={infoBarStyle}>{`S店承認（${objChildLocationCover.survey_name}：${childLocation}）`}</Box>}
                    {hasChild === true && (
                        <Approval5mcutDetail
                            props={{
                                planAreaId: childPlanAreaId,
                                branch: branch,
                                locationTraffic5mcut: objChild5mcut,
                            }}
                        />
                    )}
                    {hasChild === true && (
                        <ApprovalMarketCutDetail
                            props={{
                                planAreaId: childPlanAreaId,
                                branch: branch,
                                locationConflictMarketCut: objChildMarketCut,
                                locationConflict: childLocationConflict,
                                locationSMDS: childLocationSMDS,
                                marketCut: childMarketCutData,
                                codeMaster: codeMaster,
                            }}
                        />
                    )}
                </Box>
                <Box
                    sx={{
                        position: "fixed",
                        bottom: "50px",
                        right: "50px",
                    }}
                >
                    <Button variant="contained" color="success" size="small" sx={{ padding: "10px 20px" }} disabled={disabledApproval()} onClick={openApproval5mcutModal}>
                        承認/差戻
                    </Button>
                </Box>
                <Approval5mcutModal
                    props={{
                        open: approval5mcutModalOpen,
                        handleModal: closeApproval5mcutModal,
                        planAreaId: planAreaId,
                        childPlanAreaId: childPlanAreaId,
                        childLocation: childLocation,
                        branch: branch,
                        userData: userData,
                        planAreaInfoData: planAreaInfoData,
                    }}
                />
            </Box>
        </Box>
    );
};

export default Approval5mcut;
